<template>
  <auto-select
    v-bind="$attrs"
    v-on="$listeners"
    v-model="innerValue"
    :items="items"
    item-value="Id"
    :item-text="(item)=>trans(item)"
    return-object
    :filter="filterFunc"
  >
  </auto-select>
</template>

<script>
import { mapGetters } from "vuex";
import { translate } from "@/trans";
import AutoSelect from "@/components/AutoSelect";
export default {
  name: "trans-select",
  props: [
    "value",
    "items",
  ],
  components: {
    AutoSelect,
  },
  mounted() {},
  data() {
    return {
      innerValue: null
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
  },
  methods: {
    filterFunc(item, search) {
      console.log(item);
      return (
        translate(item, this.language.language)
          .toLowerCase()
          .indexOf(search.toLowerCase()) > -1
      );
    },
    trans(item) {
      // console.log("!@!@!@!@!@!@!@!@!@!@!@!@!@!@!@!@!@!2", item);
      return translate(item, this.language.language);
    },
  },
  watch: {
    value: {
      handler(v) {
        this.innerValue = v;
      }, immediate: true
    },
    innerValue: {
      handler(v) {
        this.$emit("update:value",v);
        this.$emit('change', v)
      }
    },
  },
};
</script>